import React from "react";

export default function ArrowDownIcon({ active }: any)
{
  return (

    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6209 5.22095L7.81753 9.02428C7.36836 9.47345 6.63336 9.47345 6.18419 9.02428L2.38086 5.22095"
        stroke={active ? "var(--color-main-text)" : 'currentColor'}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
